<!-- Estilos: _liga-ui.scss (.lx-*) y _liga-a.scss (.lx-a-*). Mapeo de estados: pasos-flujo.ts. -->
<div class="lx-pila lx-a-pasos" *ngIf="data">

  <!-- Lo que sigue: una sola acción principal -->
  <section class="lx-tarjeta lx-tarjeta--resaltada lx-a-siguiente" *ngIf="resumen.siguiente as sig"
           [class.lx-a-siguiente--corrige]="sig.estado === 'corrige'" aria-labelledby="lx-a-siguiente-titulo">
    <div class="lx-a-siguiente__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--coral]="sig.estado === 'corrige'" aria-hidden="true">
        <fa-icon [icon]="sig.icono"></fa-icon>
      </span>
      <div class="lx-a-siguiente__textos">
        <!-- `numero` es la posición entre todos los pasos (también los opcionales): el total va igual -->
        <span class="lx-hero__eyebrow">{{sig.estado === 'corrige' ? 'Corrige este paso' : 'Siguiente paso'}} · {{sig.numero}} de {{resumen.pasos.length}}</span>
        <h3 class="lx-tarjeta__titulo" id="lx-a-siguiente-titulo">{{sig.titulo}}</h3>
        <p class="lx-tarjeta__subtitulo" *ngIf="sig.subtitulo">{{sig.subtitulo}}</p>
      </div>
    </div>

    <div class="lx-alerta lx-alerta--error" *ngIf="sig.estado === 'corrige'">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">Necesitamos que lo corrijas</p>
        <p class="lx-alerta__texto" *ngIf="sig.motivo; else sinMotivo">Motivo: <strong>{{sig.motivo}}</strong></p>
        <ng-template #sinMotivo><p class="lx-alerta__texto">Revísalo y vuelve a enviarlo.</p></ng-template>
      </div>
    </div>

    <p class="lx-a-siguiente__pie" *ngIf="sig.archivos || (sig.nota && sig.estado !== 'corrige')">
      <span class="lx-chip lx-chip--suave lx-a-archivos" *ngIf="sig.archivos">{{sig.archivos}}</span>
      <span class="lx-paso__nota" *ngIf="sig.nota && sig.estado !== 'corrige'">{{sig.nota}}</span>
    </p>

    <button type="button" class="lx-btn lx-btn--primario" (click)="abrir(sig)">
      <span>{{sig.estado === 'corrige' ? 'Corregir ahora' : 'Continuar'}}</span>
      <fa-icon [icon]="iconos.flecha" aria-hidden="true"></fa-icon>
    </button>
  </section>

  <!-- Nada que hacer por ahora (los obligatorios ya están; los opcionales no detienen nada) -->
  <section class="lx-vacio" *ngIf="!resumen.siguiente" role="status">
    <ng-container *ngIf="resumen.total && resumen.listos === resumen.total; else esperando">
      <span class="lx-vacio__icono lx-a-vacio__icono--verde" aria-hidden="true"><fa-icon [icon]="iconos.meta"></fa-icon></span>
      <h3 class="lx-vacio__titulo">Ya no te falta nada</h3>
      <p class="lx-vacio__texto">Estamos revisando tu solicitud. Te avisamos qué sigue.</p>
    </ng-container>
    <ng-template #esperando>
      <span class="lx-vacio__icono" aria-hidden="true"><fa-icon [icon]="iconos.reloj"></fa-icon></span>
      <h3 class="lx-vacio__titulo">{{resumen.pasos.length ? 'Por ahora no te toca nada' : 'Aún no hay pasos para ti'}}</h3>
      <p class="lx-vacio__texto">{{resumen.pasos.length ? 'Estamos revisando lo que enviaste. Te avisamos en cuanto puedas seguir.' : 'Cuando tu solicitud tenga pasos, aparecen aquí.'}}</p>
    </ng-template>
    <!-- Opcionales que aún puede subir: se sugieren, no se exigen -->
    <ng-container *ngIf="resumen.opcionalesPendientes.length">
      <p class="lx-vacio__texto lx-a-opcionales__texto" data-test="opcionales-sugerencia">Si quieres, también puedes subir {{sugerenciaOpcionales}}.</p>
      <p class="lx-a-opcionales">
        <button type="button" class="lx-enlace" *ngFor="let p of resumen.opcionalesPendientes; trackBy: porId" (click)="abrir(p)">
          <span>{{p.titulo}}</span><fa-icon [icon]="iconos.chevron" aria-hidden="true"></fa-icon>
        </button>
      </p>
    </ng-container>
  </section>

  <!-- Todos los pasos, en el orden del flujo: en secciones plegables si llegan 2 o más.
       `pasos.length`, no `total`: los opcionales también se listan (total cuenta solo obligatorios). -->
  <ng-container *ngIf="resumen.pasos.length">
    <div class="lx-seccion">
      <div class="lx-seccion__textos">
        <h3 class="lx-seccion__titulo" id="lx-a-pasos-titulo">Todos tus pasos</h3>
        <p class="lx-seccion__texto" *ngIf="!secciones.length">{{resumen.siguiente ? 'En orden. Toca uno para abrirlo.' : 'En orden. Te decimos en qué va cada uno.'}}</p>
        <p class="lx-seccion__texto" *ngIf="secciones.length">{{resumen.siguiente ? 'Por tema. Toca una sección para abrirla.' : 'Por tema. Así va cada uno.'}}</p>
      </div>
      <span class="lx-chip lx-chip--suave">{{resumen.listos}}/{{resumen.total}} listos</span>
    </div>

    <ol class="lx-pasos" *ngIf="!secciones.length; else porSecciones" aria-labelledby="lx-a-pasos-titulo">
      <li *ngFor="let p of resumen.pasos; trackBy: porId">
        <ng-container *ngTemplateOutlet="renglon; context: {$implicit: p}"></ng-container>
      </li>
    </ol>

    <!-- Secciones: encabezado-botón (aria-expanded) + región con sus pasos -->
    <ng-template #porSecciones>
      <ul class="lx-a-secciones" aria-labelledby="lx-a-pasos-titulo">
        <li class="lx-a-seccion" *ngFor="let s of secciones; let i = index; trackBy: porClave"
            [ngClass]="'lx-a-seccion--' + s.estado" [class.is-abierta]="estaAbierta(s)">
          <h4 class="lx-a-seccion__encabezado">
            <button type="button" class="lx-a-seccion__boton" [id]="'lx-a-seccion-' + i"
                    [attr.aria-expanded]="estaAbierta(s)" [attr.aria-controls]="'lx-a-seccion-' + i + '-pasos'" (click)="alternar(s)">
              <span class="lx-a-seccion__icono" aria-hidden="true">
                <fa-icon [icon]="s.icono"></fa-icon>
                <span class="lx-paso__insignia" *ngIf="s.estado === 'listo'"><fa-icon [icon]="iconos.listo"></fa-icon></span>
                <span class="lx-paso__insignia lx-paso__insignia--alerta" *ngIf="s.estado === 'corrige'"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
              </span>
              <span class="lx-a-seccion__textos">
                <span class="lx-a-seccion__nombre">{{s.nombre}}</span>
                <span class="lx-a-seccion__pie">
                  <span class="lx-chip" [ngClass]="estados[s.estado].chip">
                    <fa-icon *ngIf="estados[s.estado].icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados[s.estado].texto}}
                  </span>
                  <span class="lx-a-seccion__avance">{{s.avance}}</span>
                </span>
              </span>
              <span class="lx-a-seccion__chevron" aria-hidden="true"><fa-icon [icon]="iconos.desplegar"></fa-icon></span>
            </button>
          </h4>
          <div class="lx-a-seccion__region" role="region" [id]="'lx-a-seccion-' + i + '-pasos'" [attr.aria-labelledby]="'lx-a-seccion-' + i">
            <div class="lx-a-seccion__interior">
              <div class="lx-a-seccion__contenido">
                <p class="lx-a-seccion__descripcion" *ngIf="s.descripcion">{{s.descripcion}}</p>
                <ol class="lx-pasos">
                  <li *ngFor="let p of s.pasos; trackBy: porId">
                    <ng-container *ngTemplateOutlet="renglon; context: {$implicit: p}"></ng-container>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </ng-template>
  </ng-container>

  <p class="lx-seguro">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
    <span>Tu información viaja cifrada y solo la usamos para tu solicitud.</span>
  </p>
</div>

<!-- Renglón de un paso (igual en la lista y dentro de cada sección) -->
<ng-template #renglon let-p>
  <button *ngIf="p.esBoton; else renglonFijo" type="button" class="lx-paso" [ngClass]="estadoDe(p).paso"
          [attr.aria-disabled]="p.estado === 'bloqueado' ? 'true' : null"
          [attr.aria-label]="p.etiquetaAria" (click)="abrir(p)">
    <ng-container *ngTemplateOutlet="contenidoPaso; context: {$implicit: p}"></ng-container>
    <span class="lx-paso__chevron" *ngIf="p.abrible" aria-hidden="true"><fa-icon [icon]="iconos.chevron"></fa-icon></span>
  </button>
  <ng-template #renglonFijo>
    <div class="lx-paso lx-paso--estatico" [ngClass]="estadoDe(p).paso">
      <ng-container *ngTemplateOutlet="contenidoPaso; context: {$implicit: p}"></ng-container>
    </div>
  </ng-template>
</ng-template>

<!-- Interior del renglón (solo <span>, va dentro de un <button>) -->
<ng-template #contenidoPaso let-p>
  <span class="lx-paso__icono" aria-hidden="true">
    <fa-icon [icon]="p.icono"></fa-icon>
    <span class="lx-paso__insignia" *ngIf="p.estado === 'listo'"><fa-icon [icon]="iconos.listo"></fa-icon></span>
    <span class="lx-paso__insignia lx-paso__insignia--alerta" *ngIf="p.estado === 'corrige'"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
  </span>
  <span class="lx-paso__textos">
    <span class="lx-paso__titulo">{{p.titulo}}</span>
    <span class="lx-paso__subtitulo" *ngIf="p.subtitulo">{{p.subtitulo}}</span>
    <span class="lx-paso__motivo" *ngIf="p.motivo">Motivo: {{p.motivo}}</span>
    <span class="lx-paso__pie">
      <span class="lx-chip" [ngClass]="estadoDe(p).chip">
        <fa-icon *ngIf="estadoDe(p).icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estadoDe(p).texto}}
      </span>
      <span class="lx-chip lx-chip--suave lx-a-opcional" *ngIf="p.opcional">Opcional</span>
      <span class="lx-chip lx-chip--suave lx-a-archivos" *ngIf="p.archivos">{{p.archivos}}</span>
      <!-- Tomado de una solicitud anterior: el renglón entero es el botón que abre el paso para reemplazarlo. -->
      <span class="lx-chip lx-chip--suave lx-a-reemplazar" *ngIf="p.reutilizado && p.abrible" data-test="chip-reemplazar">
        <fa-icon [icon]="iconos.reemplazar" aria-hidden="true"></fa-icon>Reemplazar
      </span>
      <span class="lx-paso__nota" *ngIf="p.nota">{{p.nota}}</span>
    </span>
  </span>
</ng-template>
